// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import React, { useState, useEffect } from 'react';
import { Dayjs } from 'dayjs';

// components
import MultiLivestreamDatePicker from '@/components/MultiLivestream/Schedule/DatePicker';
import Time from '@/components/ReactTime/ReactTime';

// svgs
import Caret from '@/public/svg/pbs-dropdown-triangle.svg';

// styles
import styles from '@/components/MultiLivestream/Schedule/Timeline.module.scss';

type MultiLivestreamTimelineProps = {
  handleScheduleDateChange: (date: string) => void;
  now: Dayjs;
  scheduleDate: string;
  scheduleTimes: Array<Dayjs>;
};

const MultiLivestreamTimeline = (props: MultiLivestreamTimelineProps) => {
  const { handleScheduleDateChange, now, scheduleDate, scheduleTimes } = props;

  const [timingIndicatorColumnStart, setTimingIndicatorColumnStart] =
    useState(1);
  const [timingIndicatorOffset, setTimingIndicatorOffset] = useState(`0`);

  // Determines how much of the first half hour is past
  // in order to display the moving time indicator at the correct location.
  // (As the schedule updates, this indicator will only ever appear in the first
  // half hour of the timeline)
  useEffect(() => {
    if (scheduleTimes?.length > 0) {
      const minutesIntoSchedule = now.diff(scheduleTimes[0], 'minute');
      // at the start and end of the 30 minute chunk we need to translate
      // the timing indicator so it looks right
      if (minutesIntoSchedule === 0) {
        setTimingIndicatorColumnStart(1);
        setTimingIndicatorOffset('-50%');
      } else if (minutesIntoSchedule === 29) {
        setTimingIndicatorColumnStart(28);
        setTimingIndicatorOffset('50%');
        // this case doesn't come up often - if we're 30 minutes in,
        // we're usually flipped over to the next half hour at 0 minutes into the schedule
      } else if (minutesIntoSchedule === 30) {
        setTimingIndicatorColumnStart(28);
        setTimingIndicatorOffset('75%');
      } else {
        // the majority use case
        setTimingIndicatorColumnStart(minutesIntoSchedule);
        setTimingIndicatorOffset('0');
      }
    }
  }, [now, scheduleTimes]);

  const handleDateChange = (date: string) => {
    handleScheduleDateChange(date);
  };

  return (
    <div className={styles.multi_livestream__schedule__timeline} data-sentry-component="MultiLivestreamTimeline" data-sentry-source-file="Timeline.tsx">
      <MultiLivestreamDatePicker
        now={now}
        onChange={(date) => {handleDateChange(date)}}
        scheduleDate={scheduleDate}
      data-sentry-element="MultiLivestreamDatePicker" data-sentry-source-file="Timeline.tsx" />
      {scheduleTimes.map((scheduleTime, index) => {
        return (
          <span className={styles.time_slot} key={`timeslot-${index + 1}`}>
            <Time
              dateTime={scheduleTime.format()}
              format="LT"
            />
            {index === 0 && (now.format('YYYY-MM-DD') === scheduleDate)&& (
              <Caret
                className={styles.time_indicator}
                data-testid="time-indicator"
                style={{
                  gridColumnStart: timingIndicatorColumnStart,
                  translate: timingIndicatorOffset,
                }}
              />
            )}
          </span>
        );
      })}
    </div>
  );
};

export default MultiLivestreamTimeline;
